import axios from 'axios';
import { getRequestType } from './common';
import globalData from './globalData';
const protobuf = require('./wechatPb/protobuf');
const protoJs = require('./performanceInfo');

const statRoot = protobuf.Root.fromJSON(protoJs);

/**
 * 单例模式构建方法
 */
const createAmpHandler = (() => {
  let instance;
  /**
   * AmpHandler 类
   */
  class ampHandler {
    constructor() {
      if (instance) {
        return instance; // 如果实例已存在，直接返回
      }
      // 初始化默认属性
      this.uploadHost = 'c.mcd.cn';
      this.requestSaveLimit = 10;
      this.lenLimit = 3000;
      this.allowUploadApiHost = {
        dev: 'api-dev.mcdchina.net',
        sit: 'api-sit.mcdchina.net',
        uat: 'api-uat.mcdchina.net',
        stg: 'api-stg.mcdchina.net',
        master: 'api.mcd.cn',
      };
      /**
       * 静态属性
       * ua = parser(navigator.userAgent)
       * mChannel = ua.os.name.indexOf('ios') !== -1 ? 101 : 102
       * mSysVersion = `${ua.os.name}  ${ua.os.version}`
       */
      this.staticProps = {
        mChannel: '',
        mClientType: 0,
        mDeviceManu: '',
        mIsRoot: false,
        mSysVersion: '',
        mAppVersion: '',
      };
      this.dynamicProps = {
        sid: () => '',
        meddyId: () => '',
        openId: () => '',
        tid: () => '',
        ct: () => 10,
        locationData: () => ({
          mLat: '',
          mLon: '',
          mCityName: '',
        }),
        netWorkType: () =>
          new Promise((resolve) => {
            resolve(0);
          }),
      };
      instance = this; // 保存实例
    }
    /**
     * 初始化方法
     * @param {Object} options - 初始化选项
     * @param {string} [options.uploadHost] - 上传主机地址
     * @param {Object} [options.staticProps] - 静态属性
     * @param {Object} [options.dynamicProps] - 动态属性
     * @param {Object} [options.allowUploadApiHost] - 允许上传的 api host
     * @param {number} [options.requestSaveLimit] - 请求保存限制
     */
    init(options) {
      if (!options) {
        return;
      }
      if (options.uploadHost) {
        this.uploadHost = options.uploadHost;
      }
      if (options.staticProps) {
        this.staticProps = {
          ...this.staticProps,
          ...options.staticProps,
        };
      }
      if (options.dynamicProps) {
        this.dynamicProps = {
          ...this.dynamicProps,
          ...options.dynamicProps,
        };
      }
      if (options.allowUploadApiHost) {
        this.allowUploadApiHost = {
          ...options.allowUploadApiHost,
        };
      }
      if (options.requestSaveLimit || options.requestSaveLimit === 0) {
        this.requestSaveLimit = options.requestSaveLimit;
      }
    }
    createBaseInfo() {
      const deviceInfo = statRoot.lookupType('stat.DeviceInfo');
      const locationInfo = statRoot.lookupType('stat.LocationInfo');
      const userInfo = statRoot.lookupType('stat.UserInfo');

      const deviceInfoParams = {};
      deviceInfoParams.mChannel = this.staticProps.mChannel.toString();
      deviceInfoParams.mClientType = Number(this.staticProps.mClientType);
      deviceInfoParams.mDeviceManu = this.staticProps.mDeviceManu;
      deviceInfoParams.mIsRoot = this.staticProps.mIsRoot;
      deviceInfoParams.mSysVersion = this.staticProps.mSysVersion;
      deviceInfoParams.mAppVersion = this.staticProps.mAppVersion;
      let deviceInfoObj = deviceInfo.create(deviceInfoParams);

      const userInfoParams = {
        meddyId: this.dynamicProps.meddyId(),
        sid: this.dynamicProps.sid(),
        openId: this.dynamicProps.openId(),
        tid: this.dynamicProps.tid(),
      };
      const userInfoObj = userInfo.create(userInfoParams);

      const locationInfoParams = {
        ...this.dynamicProps.locationData(),
      };
      const locationInfoObj = locationInfo.create(locationInfoParams);
      return {
        deviceInfoObj,
        locationInfoObj,
        userInfoObj,
      };
    }
    async uploadEventInfo(eventName, time, event) {
      const allInfo = statRoot.lookupType('stat.Allinfos');
      const eventInfo = statRoot.lookupType('stat.EventInfo');
      const eventInfoParams = {};
      eventInfoParams.mEventName = eventName;
      eventInfoParams.mTime = time;
      eventInfoParams.mEvents = event;
      const eventInfoObj = eventInfo.create(eventInfoParams);
      const { deviceInfoObj, userInfoObj } = this.createBaseInfo();
      const allInfoObj = allInfo.create({
        mDeviceInfo: deviceInfoObj,
        mUserInfo: userInfoObj,
        mEventInfo: [eventInfoObj],
      });
      const allInfoEncodeBuffer = allInfo.encode(allInfoObj).finish();
      axios({
        method: 'POST',
        url: `https://${this.uploadHost}/bff/collector/collect/event`,
        data: allInfoEncodeBuffer.slice().buffer,
        responseType: 'arraybuffer',
        headers: {
          ct: this.dynamicProps.ct(),
          'content-type': 'application/x-protobuf',
        },
      }).then((res) => {
        console.log(res);
      }).catch((err) => {
        console.log(err);
      });
    }
    /**
     * request 信息上报 
     * @param {Object} requestParams - request参数
     * @param {Object} responseParams - response参数
     * @param {string} [requestParams.url] - request 完整 path
     * @param {string} [requestParams.method] - request method
     * @param {string} [requestParams.href] - 请求发起页面 url
     * @param {Object} [requestParams.data] - request 请求参数集
     * @param {Object} [requestParams.header] - request 请求头信息
     * @param {number} [requestParams.timestamp] - 发起 request 的时间戳
     * @param {string} [requestParams.traceid] - 请求唯一标识
     * @param {Object} [responseParams.data] - response 返回数据集
     * @param {sting} [responseParams.data.code] - response 返回状态码
     * @param {number} [responseParams.timestamp] - 接受到 response 的时间戳
     *
     */
    async uploadPerformanceInfo(requestParams = {}, responseParams = {}) {
      if (!requestParams || !responseParams) {
        return;
      }
      let mHostName = '';
      let mPath = '';
      const apiPath = this.allowUploadApiHost;
      for (let key in apiPath) {
        const findIndex =
          (requestParams &&
            requestParams.url &&
            requestParams.url.indexOf(apiPath[key])) ||
          -1;
        if (findIndex >= 0) {
          if (
            requestParams.url &&
            requestParams.url.indexOf('api.mcd.cn') >= 0
          ) {
            mHostName = 'api.mcd.cn';
          } else if (
            requestParams.url &&
            requestParams.url.indexOf('api2.mcd.cn') >= 0
          ) {
            mHostName = 'api2.mcd.cn';
          } else {
            mHostName = apiPath[key];
          }
          mPath = requestParams.url.substring(
            8 + mHostName.length,
            requestParams.url.length
          );
        }
      }
      if (!mHostName) return;

      const allInfo = statRoot.lookupType('stat.Allinfos');
      const netInterfaceInfo = statRoot.lookupType('stat.NetInterfaceInfo');
      const netInterfaceInfoParams = {};
      netInterfaceInfoParams.mTime = Date.now();

      netInterfaceInfoParams.mProType = 2;

      netInterfaceInfoParams.mHostName = mHostName;

      netInterfaceInfoParams.mPath = mPath;

      netInterfaceInfoParams.mRequestType = getRequestType(
        requestParams.method
      );

      netInterfaceInfoParams.mNetType = await this.dynamicProps.netWorkType();

      netInterfaceInfoParams.mSignType =
        requestParams.header && requestParams.header.sv
          ? requestParams.header.sv
          : 'v3';

      netInterfaceInfoParams.mStatusCode =
        responseParams.data && responseParams.data.code;

      netInterfaceInfoParams.mProPath = requestParams.href || '';

      netInterfaceInfoParams.mReqParams =
        JSON.stringify(requestParams.data) || '{}';
      
      const headerStr = JSON.stringify(requestParams.header);

      netInterfaceInfoParams.mHeaderInfo = headerStr.substring(0, this.lenLimit);

      const mTimeConsum =
        (responseParams.timestamp || 0) - (requestParams.timestamp || 0);
      netInterfaceInfoParams.mTimeConsum = mTimeConsum > 0 ? mTimeConsum : 0;

      netInterfaceInfoParams.mTraceId = requestParams.traceid || '';

      let errorResponseStr = '';
      if (responseParams.data) {
        errorResponseStr = JSON.stringify(responseParams.data) || '{}';
      } else {
        errorResponseStr = JSON.stringify(responseParams) || '{}';
      }
      netInterfaceInfoParams.mErrorResponse = errorResponseStr.substring(
        0,
        this.lengLimit
      );

      const netInterfaceObj = netInterfaceInfo.create(netInterfaceInfoParams);
      globalData.netInterfaceLists.push(netInterfaceObj);
      if (globalData.netInterfaceLists.length > this.requestSaveLimit) {
        const { deviceInfoObj, locationInfoObj, userInfoObj } =
          this.createBaseInfo();
        const allInfoObj = allInfo.create({
          mDeviceInfo: deviceInfoObj,
          mLocationInfo:
            JSON.stringify(locationInfoObj) === '{}'
              ? undefined
              : locationInfoObj,
          mUserInfo: userInfoObj,
          mNetInterfaceInfo: globalData.netInterfaceLists,
        });
        const allInfoEncodeBuffer = allInfo.encode(allInfoObj).finish();
        axios({
          method: 'POST',
          url: `https://${this.uploadHost}/bff/collector/collect/request`,
          data: allInfoEncodeBuffer.slice().buffer,
          responseType: 'arraybuffer',
          headers: {
            ct: this.dynamicProps.ct(),
            'content-type': 'application/x-protobuf',
          },
        }).then((res) => {
          console.log(res);
        }).catch((err) => {
          console.log(err);
        });;
        globalData.netInterfaceLists = [];
      }
    }
  }
  return new ampHandler();
})();

export default createAmpHandler;
